const profiles = {
  CONSULTOR: 'CONSULTOR',
  USER: 'USER',
};

const PROFILES = Object.freeze(profiles);
export default profiles;
export { PROFILES };
